'use client'

import { GrainySvgGradientFilter } from '@components/primitives/Gradient/GrainySvgGradientFilter'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import { HomePageSearchWidget } from '../SearchWidget/index.client'

export default function ExplorePanel() {
  return (
    <>
      <div
        className='relative mx-auto my-24 flex w-full flex-col items-center gap-8 rounded-xl px-6 pb-14 pt-16'
        style={{
          background: `
          radial-gradient(76.44% 89.36% at 75.2% 94.81%, rgba(167, 205, 255, 0.40) 0%, rgba(167, 205, 255, 0.00) 100%),
          linear-gradient(218deg, rgba(193, 115, 255, 0.35) 20.91%, rgba(153, 123, 242, 0.45) 78.24%)
          `,
        }}
      >
        <GrainySvgGradientFilter />
        <div className='relative flex flex-col items-center gap-4'>
          <h3 className='text-center text-3xl font-bold text-black'>
            Explore Cutting-Edge Treatments
          </h3>
          <h5 className='text-center text-2xl text-neutral700 md:w-3/4'>
            Browse clinical trials by condition and location, then choose your
            ideal trial by comparing trial details and key eligibility criteria
          </h5>
          <div className='relative w-full'>
            <HomePageSearchWidget source={TrackingSources.HOMEPAGE_TOP_CTA} />
          </div>
        </div>
      </div>
    </>
  )
}
